import { DateTime } from 'luxon';
export default function formatDateTime(
	date: Date,
	timeZone: string,
	dateFormat: string,
) {
	return DateTime.fromJSDate(date)
		.setZone(timeZone)
		.toFormat(momentToLuxonFormat(dateFormat));
}

const momentToLuxonDateFormatMap: Record<string, string> = {
	DD: 'dd',
	MM: 'LL',
	YYYY: 'yyyy',
	A: 'a',
};

export const momentToLuxonFormat = (format: string) => {
	let luxonFormat = format ?? 'LL/dd/yyyy';
	Object.entries(momentToLuxonDateFormatMap).forEach(
		([momentToken, luxonToken]) => {
			luxonFormat = luxonFormat.replace(momentToken, luxonToken);
		},
	);

	return luxonFormat;
};
